<div class="inventory-report" [class.inventory-report--expanded]="expanded">
  <a routerLink="/admin" class="inventory-report__back-link">
    <mat-icon class="material-symbols-outlined">arrow_back</mat-icon>
    {{ 'TRANS__SECTION__ADMIN__TITLE' | translate }}
  </a>

  <header class="inventory-report__header">
    <div>
      <div class="inventory-report__title">
        <h1>{{ 'TRANS__INVENTORY_REPORT__REPORTS_TITLE' | translate }}</h1>
      </div>
    </div>
    <div class="inventory-report__header-actions">
      @if (selectedTab === 0) {
        <span class="inventory-report__print-date">
          {{ 'TRANS__INVENTORY_REPORT__PRINT_DATE' | translate }}:
          {{ printedAt | date:'dd.MM.yyyy HH:mm' }}
        </span>
      }
      <button
        mat-stroked-button
        class="inventory-report__print-button"
        [class.inventory-report__print-button--loading]="preparingPrint"
        [attr.aria-busy]="preparingPrint"
        type="button"
        [disabled]="currentLoading || preparingPrint || currentItems.length === 0"
        (click)="printReport()"
      >
        <span class="inventory-report__print-button-content">
          @if (preparingPrint) {
            <mat-spinner diameter="20"></mat-spinner>
          }
          @if (!preparingPrint) {
            <mat-icon class="material-symbols-outlined">print</mat-icon>
          }
          <span>
            {{ (preparingPrint
              ? 'TRANS__INVENTORY_REPORT__PREPARING_IMAGES'
              : 'TRANS__INVENTORY_REPORT__PRINT_PREVIEW') | translate }}
          </span>
        </span>
      </button>
    </div>
  </header>

  <nav mat-tab-nav-bar class="inventory-report__tabs" [tabPanel]="reportTabPanel"
    [attr.aria-label]="'TRANS__INVENTORY_REPORT__REPORTS_TITLE' | translate">
    <a mat-tab-link [active]="selectedTab === 0" (click)="tabChanged(0)">
      <mat-icon class="material-symbols-outlined">inventory_2</mat-icon>
      {{ 'TRANS__INVENTORY_REPORT__PREPAREDNESS_TITLE' | translate }}
    </a>
    <a mat-tab-link [active]="selectedTab === 1" (click)="tabChanged(1)">
      <mat-icon class="material-symbols-outlined">delete_outline</mat-icon>
      {{ 'TRANS__INVENTORY_REPORT__DELETED_TITLE' | translate }}
    </a>
  </nav>

  <mat-tab-nav-panel #reportTabPanel class="inventory-report__tab-panel-container">

  <div class="inventory-report__tab-panel">

  <section class="inventory-report__filters">
    @if (selectedTab === 1) {
      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>{{ 'TRANS__DAMS_DIALOG__DATE_FROM' | translate }}</mat-label>
        <input matInput [matDatepicker]="deletedFromPicker" [value]="deletedFromDate"
          [max]="deletedToDate" autocomplete="off"
          (dateChange)="deletedFromDate = $event.value?.format('YYYY-MM-DD') ?? ''; deletedDatesChanged()">
        <mat-datepicker-toggle matSuffix [for]="deletedFromPicker"></mat-datepicker-toggle>
        <mat-datepicker #deletedFromPicker></mat-datepicker>
      </mat-form-field>
      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>{{ 'TRANS__DAMS_DIALOG__DATE_TO' | translate }}</mat-label>
        <input matInput [matDatepicker]="deletedToPicker" [value]="deletedToDate"
          [min]="deletedFromDate" autocomplete="off"
          (dateChange)="deletedToDate = $event.value?.format('YYYY-MM-DD') ?? ''; deletedDatesChanged()">
        <mat-datepicker-toggle matSuffix [for]="deletedToPicker"></mat-datepicker-toggle>
        <mat-datepicker #deletedToPicker></mat-datepicker>
      </mat-form-field>
    }
    <div class="inventory-report__search-type-filters">
      <mat-form-field
        class="inventory-report__filter-field"
        appearance="outline"
        subscriptSizing="dynamic"
      >
        <mat-label>
          {{ 'TRANS__REPORTS_V2_FILTER_IN_REPORTLIST' | translate }}
        </mat-label>
        <input
          matInput
          type="search"
          [formControl]="selectedTab === 0 ? filterControl : deletedFilterControl"
        >
        <mat-icon class="material-symbols-outlined" matSuffix>search</mat-icon>
      </mat-form-field>

      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>
          {{ 'TRANS__ADVANCED_SEARCH__FILTER__SELECT_OBJECT_TYPE_LABEL' | translate }}
        </mat-label>
        <mat-select
          multiple
          [disabled]="selectedTab === 0 ? !objectTypeFilterSupported || !objectTypeGroups.length : !deletedObjectTypeGroups.length"
          [value]="selectedTab === 0 ? selectedObjectTypes : deletedSelectedObjectTypes"
          (selectionChange)="selectedTab === 0 ? objectTypesChanged($event.value) : deletedObjectTypesChanged($event.value)"
        >
          <mat-option [value]="allObjectTypes">
            {{ 'TRANS__ADVANCED_SEARCH__FILTER__DELETED_STATE__ALL' | translate }}
          </mat-option>
          @for (group of (selectedTab === 0 ? objectTypeGroups : deletedObjectTypeGroups); track group.groupId) {
            <mat-optgroup [label]="group.groupName | translate">
              @for (option of group.options; track option.id) {
                <mat-option [value]="option.id">{{ option.name | translate }}</mat-option>
              }
            </mat-optgroup>
          }
        </mat-select>
      </mat-form-field>
    </div>
  </section>

  <mat-expansion-panel class="inventory-report__advanced-options mat-elevation-z0">
    <mat-expansion-panel-header>
      <mat-panel-title>
        {{ 'TRANS__INVENTORY_REPORT__OPTIONS_TITLE' | translate }}
      </mat-panel-title>
    </mat-expansion-panel-header>
    <p>{{ 'TRANS__INVENTORY_REPORT__REQUIRED_COLUMNS_HELP' | translate }}</p>
    <div class="inventory-report__options-fields">
      @for (column of optionalColumns; track column.key) {
        @if (selectedTab === 0 || (column.key !== 'image' && column.key !== 'salvagePriority')) {
          <mat-checkbox [checked]="column.enabled"
            (change)="toggleColumn(column.key, $event.checked)">
            {{ column.label | translate }}
          </mat-checkbox>
        }
      }
      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>
          {{ 'TRANS__INVENTORY_REPORT__MAX_DESCRIPTION_LENGTH' | translate }}
        </mat-label>
        <mat-select [(value)]="descriptionMaxLength">
          @for (option of descriptionLengthOptions; track option.value) {
            <mat-option [value]="option.value">
              @if (option.value === 0) {
                {{ 'TRANS__INVENTORY_REPORT__FULL_TEXT' | translate }}
              } @else {
                {{ 'TRANS__INVENTORY_REPORT__CHARACTER_COUNT' |
                  translate: option.translationParams }}
              }
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  </mat-expansion-panel>

  @if (generationSupported) {
    <section
      class="inventory-report__file-generation"
      aria-labelledby="file-generation-heading"
    >
      <div class="inventory-report__file-generation-description">
        <h2 id="file-generation-heading">
          {{ 'TRANS__INVENTORY_REPORT__FILE_TITLE' | translate }}
        </h2>
        <p>{{ 'TRANS__INVENTORY_REPORT__FILE_HELP' | translate }}</p>

        @if (activeGeneration) {
          <div class="inventory-report__file-status" aria-live="polite">
            <mat-spinner diameter="20"></mat-spinner>
            <span>
              {{ generationStatusTranslation(activeGeneration.status) |
                translate }}
            </span>
          </div>
        } @else if (latestGeneration) {
          <div class="inventory-report__latest-file">
            <mat-icon class="material-symbols-outlined" aria-hidden="true">
              description
            </mat-icon>
            <span>
              <strong>{{ latestGeneration.file_name }}</strong>
              @if (latestGeneration.finished_at) {
                · {{ latestGeneration.finished_at | date:'dd.MM.yyyy HH:mm' }}
              }
              @if (latestGeneration.row_count !== null) {
                · {{ latestGeneration.row_count | number }}
                {{ 'TRANS__FIELD__OBJECTS' | translate }}
              }
            </span>
          </div>
        } @else {
          <p class="inventory-report__no-file">
            {{ 'TRANS__INVENTORY_REPORT__NO_FILE' | translate }}
          </p>
        }

        @if (generationErrorMessage) {
          <p class="inventory-report__file-error" role="alert">
            {{ generationErrorMessage | translate }}
          </p>
        }
      </div>

      <div class="inventory-report__file-actions">
        @if (latestGeneration?.download_available) {
          <button
            mat-stroked-button
            type="button"
            [disabled]="downloadingFile"
            (click)="downloadLatestFile()"
          >
            <mat-icon class="material-symbols-outlined">download</mat-icon>
            {{ 'TRANS__JOB_STATUS__DOWNLOAD' | translate }}
          </button>
        }
        <button
          mat-flat-button
          type="button"
          [disabled]="generationLoading || activeGeneration !== null || (selectedTab === 1 && !deletedDateRangeValid())"
          (click)="generateFile()"
        >
          @if (generationLoading) {
            <mat-spinner diameter="20"></mat-spinner>
          } @else {
            <mat-icon class="material-symbols-outlined">add</mat-icon>
          }
          {{ 'TRANS__INVENTORY_REPORT__GENERATE_FILE' | translate }}
        </button>
      </div>
    </section>
  }

  @if (currentError) {
    <div
      class="inventory-report__message inventory-report__message--error"
      role="alert"
    >
      <span>{{ currentError | translate }}</span>
      <button mat-button type="button" (click)="retry()"
        [disabled]="currentLoading || (selectedTab === 1 && !deletedDateRangeValid())">
        {{ 'TRANS__INVENTORY_REPORT__TRY_AGAIN' | translate }}
      </button>
    </div>
  }

  <div class="inventory-report__preview-heading">
    <div>
      <h2>{{ (selectedTab === 0
        ? 'TRANS__INVENTORY_REPORT__PREPAREDNESS_TITLE'
        : 'TRANS__INVENTORY_REPORT__DELETED_TITLE') | translate }}</h2>
      <p>{{ (selectedTab === 0
        ? 'TRANS__INVENTORY_REPORT__PREPAREDNESS_HELP'
        : 'TRANS__INVENTORY_REPORT__DELETED_HELP') | translate }}</p>
      <p>{{ 'TRANS__INVENTORY_REPORT__PREVIEW_HELP' | translate: {count: previewLimit} }}</p>
    </div>
    <button mat-stroked-button type="button" (click)="expanded = !expanded"
      [attr.aria-expanded]="expanded" aria-controls="inventory-report-table">
      <mat-icon class="material-symbols-outlined">{{ expanded ? 'close_fullscreen' : 'open_in_full' }}</mat-icon>
      {{ (expanded ? 'TRANS__INVENTORY_REPORT__RESTORE_VIEW'
        : 'TRANS__INVENTORY_REPORT__EXPAND_VIEW') | translate }}
    </button>
  </div>

  <div id="inventory-report-table"
    class="inventory-report__table-container"
    [class.inventory-report__table-container--loading]="currentLoading"
  >
    @if (currentLoading) {
      <div
        class="inventory-report__loading"
        [attr.aria-label]="'TRANS__INVENTORY_REPORT__LOADING' | translate"
      >
        <mat-spinner diameter="40"></mat-spinner>
      </div>
    }

    <table
      mat-table
      matSort
      matSortDisableClear
      class="inventory-report__table"
      [dataSource]="currentItems"
      [matSortActive]="selectedTab === 0 ? sortField : deletedSortField"
      [matSortDirection]="selectedTab === 0 ? sortDirection : deletedSortDirection"
      [matSortDisabled]="currentLoading"
      (matSortChange)="sortChanged($event)"
    >
      <caption class="inventory-report__caption">
        {{ (selectedTab === 0 ? 'TRANS__INVENTORY_REPORT__TITLE'
          : 'TRANS__ADVANCED_SEARCH__FILTER__DELETED_STATE__DELETED_ONLY') | translate }}
      </caption>

      <ng-container matColumnDef="image">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'TRANS__INVENTORY_REPORT__COLUMN__IMAGE' | translate }}
        </th>
        <td mat-cell *matCellDef="let item">
          @if (item.thumbnail_url && !failedImageIds.has(item.artifact_id)) {
            <img
              class="inventory-report__thumbnail"
              [src]="item.thumbnail_url"
              [alt]="'TRANS__THUMBNAIL__IMAGE' | translate"
              loading="lazy"
              (error)="imageFailed(item.artifact_id)"
            >
          } @else if (item.thumbnail_url) {
            <mat-icon
              class="inventory-report__image-placeholder material-symbols-outlined"
              aria-hidden="true"
            >
              broken_image
            </mat-icon>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="identificationNumber">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header="identification_number"
        >
          {{ 'TRANS__INVENTORY_REPORT__COLUMN__IDENTIFICATION_NUMBER' |
            translate }}
        </th>
        <td mat-cell *matCellDef="let item">{{ item.identification_number }}</td>
      </ng-container>

      <ng-container matColumnDef="designation">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header="designation"
          [disabled]="selectedTab === 1"
        >
          {{ 'TRANS__INVENTORY_REPORT__COLUMN__DESIGNATION' | translate }}
        </th>
        <!-- HTML: names of invalid concepts come wrapped in <del>. -->
        <td mat-cell *matCellDef="let item" [innerHTML]="designations(item)"></td>
      </ng-container>

      <ng-container matColumnDef="title">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="title" [disabled]="selectedTab === 1">
          {{ 'TRANS__INVENTORY_REPORT__COLUMN__TITLE' | translate }}
        </th>
        <td mat-cell *matCellDef="let item">{{ item.title }}</td>
      </ng-container>

      <ng-container matColumnDef="count">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'TRANS__INVENTORY_REPORT__COLUMN__COUNT' | translate }}
        </th>
        <td mat-cell *matCellDef="let item">{{ item.count }}</td>
      </ng-container>

      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'TRANS__INVENTORY_REPORT__COLUMN__DESCRIPTION' | translate }}
        </th>
        <td
          mat-cell
          *matCellDef="let item"
          class="inventory-report__long-text"
        >
          {{ truncateDescription(item.description) }}
        </td>
      </ng-container>

      <ng-container matColumnDef="motifDescription">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'TRANS__INVENTORY_REPORT__COLUMN__MOTIF_DESCRIPTION' |
            translate }}
        </th>
        <td
          mat-cell
          *matCellDef="let item"
          class="inventory-report__long-text"
        >
          {{ item.motif_description }}
        </td>
      </ng-container>

      <ng-container matColumnDef="placement">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="placement">
          {{ 'TRANS__INVENTORY_REPORT__COLUMN__PLACEMENT' | translate }}
        </th>
        <td mat-cell *matCellDef="let item">
          <div>{{ item.current_placement }}</div>
          @if (item.current_placement_code) {
            <small>{{ item.current_placement_code }}</small>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="collection">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="collection" [disabled]="selectedTab === 1">
          {{ 'TRANS__FIELD__COLLECTION' | translate }}
        </th>
        <td mat-cell *matCellDef="let item">{{ item.collection }}</td>
      </ng-container>

      <ng-container matColumnDef="owner">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'TRANS__INVENTORY_REPORT__COLUMN__OWNER' | translate }}
        </th>
        <td mat-cell *matCellDef="let item">{{ item.owner }}</td>
      </ng-container>

      <ng-container matColumnDef="registeredAt">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header="registered_at"
        >
          {{ 'TRANS__INVENTORY_REPORT__COLUMN__REGISTERED_AT' | translate }}
        </th>
        <td mat-cell *matCellDef="let item">
          {{ item.registered_at | date:'dd.MM.yyyy HH:mm' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="registeredBy">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'TRANS__INVENTORY_REPORT__COLUMN__REGISTERED_BY' | translate }}
        </th>
        <td mat-cell *matCellDef="let item">{{ item.registered_by }}</td>
      </ng-container>

      <ng-container matColumnDef="internalInformation">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'TRANS__INVENTORY_REPORT__COLUMN__INTERNAL_INFORMATION' |
            translate }}
        </th>
        <td
          mat-cell
          *matCellDef="let item"
          class="inventory-report__long-text"
        >
          {{ item.internal_information }}
        </td>
      </ng-container>

      <ng-container matColumnDef="salvagePriority">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'TRANS__INVENTORY_REPORT__COLUMN__SALVAGE_PRIORITY' | translate }}
        </th>
        <td mat-cell *matCellDef="let item">
          {{ (item.salvage_priority_registered
            ? 'TRANS__FIELD__BOOLEAN__YES'
            : 'TRANS__FIELD__BOOLEAN__NO') | translate }}
        </td>
      </ng-container>

      <ng-container matColumnDef="deletedAt">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="deleted_at">{{ 'TRANS__JOB_STATUS__DELETED' | translate }}</th>
        <td mat-cell *matCellDef="let item">{{ item.deleted_at | date:'dd.MM.yyyy HH:mm' }}</td>
      </ng-container>
      <ng-container matColumnDef="deletedBy">
        <th mat-header-cell *matHeaderCellDef>{{ 'TRANS__INVENTORY_REPORT__COLUMN__DELETED_BY' | translate }}</th>
        <td mat-cell *matCellDef="let item">{{ item.deleted_by }}</td>
      </ng-container>
      <ng-container matColumnDef="deletionReason">
        <th mat-header-cell *matHeaderCellDef>{{ 'TRANS__FIELD__DELETE_OBJECT_REASON' | translate }}</th>
        <td mat-cell *matCellDef="let item">{{ item.deletion_reason }}</td>
      </ng-container>
      <ng-container matColumnDef="artifactId">
        <th mat-header-cell *matHeaderCellDef>ID</th>
        <td mat-cell *matCellDef="let item">{{ item.artifact_id }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="selectedTab === 0 ? displayedColumns : deletedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: selectedTab === 0 ? displayedColumns : deletedColumns"></tr>
    </table>

    @if (currentLoaded && !currentLoading && !currentError && currentItems.length === 0) {
      <p class="inventory-report__empty-message">
        {{ 'TRANS__INVENTORY_REPORT__NO_OBJECTS' | translate }}
      </p>
    }
  </div>

  </div>
  </mat-tab-nav-panel>
</div>
